import { RiskLevel, RiskLevelLabel } from '@idc-forms/types/risk-level'

export { RiskLevel, RiskLevelLabel }

// FE-only: array para <select> con colores
export const RISK_LEVEL_OPTIONS = [
  { label: RiskLevelLabel[RiskLevel.LOW], value: RiskLevel.LOW, color: '#0086EA' },
  { label: RiskLevelLabel[RiskLevel.LOW_MEDIUM], value: RiskLevel.LOW_MEDIUM, color: '#00B050' },
  { label: RiskLevelLabel[RiskLevel.HIGH_MEDIUM], value: RiskLevel.HIGH_MEDIUM, color: '#FF0' },
  { label: RiskLevelLabel[RiskLevel.HIGH], value: RiskLevel.HIGH, color: '#F00' }
]

// Aliases temporales — borrar cuando se actualicen los consumers
export const EnumRiskLevel = RiskLevel
export type EnumRiskLevel = RiskLevel
export const NAME_RISK_LEVEL = RiskLevelLabel
